import Theme from "../../components/Theme";
import AppStorage from "../../components/AppStorage";
import Hero from "../../components/organisms/customers/Hero";
import People from "../../components/organisms/common/People";
import WideCTA from "../../components/organisms/common/WideCTA";
import SecondFold from "../../components/organisms/customers/SecondFold";
import Highlight from "../../components/organisms/customers/Highlight";
import CTA from "../../components/organisms/common/CTA";
import CustomerStories from "../../components/organisms/customers/CustomerStories";
export async function getStaticPaths({ locales }) {
  // Fetch All Path
  const res = await fetch(`${process.env.JSON_PATH}/routes.json`);
  const data = await res.json();

  // Specific Paths
  let routes = data.customers;

  // Variable for returning path
  let paths = [];

  // Create Paths with locales
  routes.forEach((path) => {
    for (const locale of locales) {
      paths.push({
        params: {
          page: path,
        },
        locale,
      });
    }
  });
  // return to getStaticProps()
  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps({ params, locale }) {
  let allData = {};

  // Fetch
  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );
  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );
  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/customers/${params.page}.json`
  );

  // Catch Error
  if (contentResponse.status === 404) {
    return {
      notFound: true,
    };
  }

  // Convert
  allData.header = await headerResponse.json();
  allData.footer = await footerResponse.json();
  allData.content = await contentResponse.json();

  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };

  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...allData.content,
  };

  return {
    props: {
      data,
      pageName: params.page,
    },
  };
}
export default function CustomerPage({ data, pageName, nonce }) {
  const header = data.header;
  const footer = data.footer;
  const content = data.page_content;
  const helper = data.page_helper;
  const seo = data.page_meta;
  return (
    <>
      <Theme
        className={`customer-template ${helper.pageName}`}
        header={header}
        footer={footer}
        nonce={nonce}
        seo={seo}
      >
        <AppStorage pageName={`Customer Sub Page - ${pageName}`} />
        <Hero data={content.hero} />
        <SecondFold data={content.secondFold} />
        <section className="container lg:pt-10 md:pt-5 highlight-section">
          <Highlight data={content.highlightSection} />
        </section>
        <CTA
          className="bg-offset-bottom lg:pt-20 md:pt-11 cta-w-image-section"
          data={content.cta}
        />
        <CustomerStories data={content.customerStoriesSection} />
        <People className="bg-light" />
        <WideCTA data={content.wideCTA} />
      </Theme>
    </>
  );
}
